import TripStatisticsApi from "../../services/api/TripStatistics";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getQueryParams } from "../../utils";

function handleError(err) {
  console.log("error in trip statistics actions:", err);
}

export const setTripStatisticsData = (payload) => {
  return {
    type: ActionTypes.SET_TRIP_STATISTICS_DATA,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_TRIP_STATISTICS,
    payload,
  };
};

export const getTripStatistics = (data) => async (dispatch) => {
  try {
    const queryParams = getQueryParams(data);
    dispatch(setLoader(true));
    const response = await TripStatisticsApi.getTripStatistics(queryParams);
    if (response) {
      dispatch(setLoader(false));
      dispatch(setTripStatisticsData(response));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(resetState({ state: "tripStatisticsData" }));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
